import React, { useCallback, useEffect, useState } from "react";
import WhiteListDevicePopup from "../../components/Popup/WhiteListDevicePopup";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import WhiteListDevicePanelOptional from "../../components/ControlPanel/PanelOptional/WhiteListDevicePanelOptional";
import WhiteListDeviceControlPanel from "../../components/ControlPanel/WhiteListDeviceControlPanel";
import useDebounce from "src/hooks/useDebounce";
import useControlPanel from "src/hooks/useControlPanel";
import Pagination from "src/components/Pagination/Pagination";
import WhiteListDeviceTable from "../../components/Table/WhiteListDeviceTable";
import { path } from "src/constants/path";
import { getDeviceDetail, getDevices } from "src/apis/CMS/device.api";

const initWhiteListDevice = {
  list: [],
  total_record: 0,
};

const Devices = () => {
  const {
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [deviceData, setDeviceData] = useState(initWhiteListDevice);
  const [openPopup, setOpenPopup] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [activationStatus, setActivationStatus] = useState("all");
  const [isRefresh, setIsRefresh] = useState(true);

  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
      activationStatus,
    };
    getDevices(query, (result) => {
      setDeviceData(result);
    });
  }, [activationStatus, endDate, limit, numberPage, search, startDate, status]);

  const handleStatusChange = useCallback((newStatus) => {
    setActivationStatus(newStatus);
  }, []);

  const handleUploadFile = useCallback(() => {
    setIsRefresh(!isRefresh);
  }, [isRefresh]);

  const openInPopup = (mac) => {
    setOpenPopup(true);
    getDeviceDetail(mac, (result) => {
      setRecordForEdit(result);
    });
  };

  return (
    <div className="container">
      {/* upload file section */}
      <WhiteListDevicePopup
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        recordForEdit={recordForEdit}
      />
      <WhiteListDeviceControlPanel onUploadSuccess={handleUploadFile}>
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
        <WhiteListDevicePanelOptional onStatusChange={handleStatusChange} />
      </WhiteListDeviceControlPanel>

      <h3 style={{ marginBottom: "10px" }}>{`${
        activationStatus === "all"
          ? "Total device"
          : "Total device " + activationStatus
      }: ${deviceData.total_record}`}</h3>
      <WhiteListDeviceTable
        data={deviceData.list}
        handleOpenPopup={openInPopup}
        status={status}
      />

      <Pagination
        pathname={path.cmsDevice}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={deviceData.total_record}
      />
    </div>
  );
};

export default Devices;
